import React from 'react';
import { ListDietDiaryResponseElement } from '../../../types/apiGeneratedTypes';
import { formatInTimeZone } from 'date-fns-tz';
import { mealTypesNames } from '../../../utils/constants';

type Props = { dietRecord: ListDietDiaryResponseElement };

const DietDiaryTableRow = ({ dietRecord }: Props) => {
  return (
    <div className='table-row'>
      <div className='date'>
        {dietRecord?.meal_time
          ? formatInTimeZone(
              new Date(dietRecord?.meal_time),
              'UTC',
              'dd/MM/yyyy'
            )
          : '-'}
      </div>
      <div className='time'>
        {dietRecord?.meal_time
          ? formatInTimeZone(new Date(dietRecord?.meal_time), 'UTC', 'hh:mm a')
          : '-'}
      </div>
      <div className='meal-type'>
        <div className='meal-type-container'>
          {dietRecord?.meal_type ? mealTypesNames[dietRecord.meal_type] : '-'}
        </div>
      </div>
      <div className='meal-note'>{dietRecord?.note}</div>
    </div>
  );
};

export default DietDiaryTableRow;
